import { useEffect, useState } from 'react';
const SelectClass = ({
  setDisable,
  setLoading,
  classData,
  setClassData,
  courses,
  batchStructures,
  batches,
  loadingCourses,
  loadingStructures,
  loadingBatches,
  fetchBatchStructures,
  fetchBatchesByStructure,
}) => {
  const [errors, setErrors] = useState([]);
  const handleCourseChange = async (event) => {
    const courseId = event.target.value;

    // Reset batch structure and batch when course changes
    setClassData({
      courseId,
      batchStructureId: '',
      batchId: '',
    });
    if (courseId) {
      await fetchBatchStructures(courseId);
    }
  };
  const handleStructureChange = async (event) => {
    const batchStructureId = event.target.value;

    // Reset batch when structure changes
    setClassData((prev) => ({
      ...prev,
      batchStructureId,
      batchId: '',
    }));
    if (batchStructureId) {
      await fetchBatchesByStructure(batchStructureId);
    }
  };
  const handleBatchChange = (event) => {
    const batchId = event.target.value;
    setClassData((prev) => ({ ...prev, batchId }));
  };
  useEffect(() => {
    const newErrors = [];
    if (!classData?.courseId) {
      newErrors.push('Please select a course.');
    }
    if (!classData?.batchStructureId) {
      newErrors.push('Please select a batch structure.');
    }
    if (!classData?.batchId) {
      newErrors.push('Please select a batch.');
    }
    setErrors(newErrors);
    setDisable(newErrors.length > 0);
  }, [classData, setDisable]);
  return (
    <div className="w-full rounded-lg px-3 pt-7 md:px-8">
      <div className="flex justify-center">
        <h4 className="text-lg font-bold text-navy-700 dark:text-white">
          Select Class Information
        </h4>
      </div>
      <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-center md:gap-6">
        {/* Course Select */}
        <div className="w-full md:w-1/3">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Course
          </label>
          <select
            onChange={handleCourseChange}
            value={classData?.courseId}
            name="course"
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">Click here to Select Course</option>
            {loadingCourses ? (
              <option>Loading courses...</option>
            ) : courses.length === 0 ? (
              <option disabled>No courses available</option>
            ) : (
              courses.map((course, i) => (
                <option key={course._id} value={course._id}>
                  {i + 1}. {course.courseName}
                </option>
              ))
            )}
          </select>
        </div>
        {/* Batch Structure Select */}
        <div className="w-full md:w-1/3">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Batch Structure
          </label>
          <select
            onChange={handleStructureChange}
            value={classData?.batchStructureId}
            name="batchStructure"
            disabled={!classData?.courseId || loadingStructures}
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none disabled:opacity-50 dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">
              {loadingStructures
                ? 'Loading structures...'
                : !classData?.courseId
                ? 'Select course first'
                : 'Click here to Select Structure'}
            </option>
            {!loadingStructures &&
              batchStructures.map((bs, i) => (
                <option key={bs._id} value={bs._id}>
                  {i + 1}. {bs.name}
                </option>
              ))}
          </select>
        </div>
        {/* Batch Select */}
        <div className="w-full md:w-1/3">
          <label className="ml-3 text-sm font-bold text-navy-700 dark:text-white">
            Select Batch
          </label>
          <select
            onChange={handleBatchChange}
            value={classData?.batchId}
            name="batch"
            disabled={!classData?.batchStructureId || loadingBatches}
            className="mt-2 w-full rounded-xl border border-gray-200 py-3 pl-2.5 pr-3 text-sm font-normal outline-none disabled:opacity-50 dark:!border-white/10 dark:!bg-navy-800 dark:text-white"
          >
            <option value="">
              {loadingBatches
                ? 'Loading batches...'
                : !classData?.batchStructureId
                ? 'Select structure first'
                : 'Click here to Select Batch'}
            </option>
            {!loadingBatches &&
              batches.length > 0 &&
              batches.map((batch) => {
                const times = Array.isArray(batch.daySchedules)
                  ? batch.daySchedules.map((d) => d.startTime).filter(Boolean)
                  : [];
                const uniqueTimes = [...new Set(times)];
                const timeDisplay =
                  uniqueTimes.length > 0
                    ? ` at ${uniqueTimes.join(' / ')}`
                    : '';
                return (
                  <option key={batch._id} value={batch._id}>
                    B {batch.batchNumber} – From{' '}
                    {new Date(batch.startDate).toLocaleDateString()} to{' '}
                    {new Date(batch.endDate).toLocaleDateString()}
                    {timeDisplay}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
      {errors.length > 0 && (
        <div className="mt-4 text-center text-red-500">
          {errors.map((error, index) => (
            <p key={index}>{error}</p>
          ))}
        </div>
      )}
    </div>
  );
};
export default SelectClass;
